import AddProject from '../Layout/Project/addProject'

const AddProjectPage = () => {
  return <AddProject />
}

export default AddProjectPage
